<template>
  <div class="main-header">
    <div class="logo">
      <a href="/home">
        <img class="logo-img" src="@/assets/logo-white.png" />
        智会云（天津）会议展览有限公司
      </a>
    </div>
    <div class="nav">
      <div class="i-nav" @click="tagNav">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul :class="{show: navVisiable}">
        <li :class="{active: urlName == 'Home'}"><router-link to="/home">首页</router-link></li>
        <li :class="{active: urlName == 'Service'}"><router-link to="/service">服务介绍</router-link></li>
        <li :class="{active: urlName == 'CaseSharing' || urlName == 'Award' || urlName == 'PlatformServices' || urlName == 'TrainingService' || urlName == 'Meeting' || urlName == 'TrainingServiceDetail' || urlName == 'AwardDetail'}" class="case">
          <router-link to="/case-sharing">案例分享</router-link>
          <ul class="case-item">
            <li><router-link to="/platform-services">平台服务</router-link></li>
            <li><router-link to="/training-service">人才网络</router-link></li>
            <li><router-link to="/meeting">智能会议</router-link></li>
          </ul>
        </li>
        <li :class="{active: urlName == 'About' || urlName == 'GroupOverview' || urlName == 'ChairmanMessage' || urlName == 'ContactUs'|| urlName == 'Recruit' || urlName == 'RecruitDetail' }" class="about">
          <router-link to="/about">关于我们</router-link>
          <ul class="about-item">
            <li><router-link to="/group-overview">公司概况</router-link></li>
            <li><router-link to="/recruit">人才招聘</router-link></li>
            <li><router-link to="/contact-us">联系我们</router-link></li>
            <li><router-link to="/chairman-message">董事长寄语</router-link></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Head',
    data() {
      return {
        urlName: 'Home',
        navVisiable: false
      }
    },
    methods: {
      tagNav() {
        this.navVisiable = !this.navVisiable
      }
    },
    mounted() {
      this.urlName = this.$route.name || 'Home'
    },
    watch: {
      $route(to, from) {
        this.navVisiable = false
        this.urlName = to.name
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@media (min-width: 997px) {
  .main-header {
    padding: 0 10%;
    height: 80px;
    .logo {
      margin-top: 39px;
      .logo-img {
        margin-right: 13px;
      }
      a {
        font-size: 24px;
      }
    }
    .i-nav {
      display: none;
    }
    .nav {
      right: 10%;
      width: 425px;
      position: absolute;
      bottom: 0;
      li {
        height: 42px;
        line-height: 42px;
        padding: 0 20px;
        float: left;
        margin: 0 5px;
        position: relative;
        a {
          display: block;
          font-size: 16px;
          height: 42px;
          line-height: 42px;
        }
      }
      li:hover {
        border-bottom: 5px solid #00c9da;
      }
      .active {
        border-bottom: 5px solid #00c9da;
      }
    }
    .case-item, .about-item {
      position: absolute;
      width: 110%;
      left: -5%;
      display: none;
      li {
        display: block;
        padding: 0!important;
        margin: 0!important;
        float: none;
        width: 100%;
        background: rgba(0, 0, 0, 0.7);
        border-bottom: 1px solid rgba(255,255,255,0.4);
        height: 54px!important;
        line-height: 54px!important;
        a {
          text-align: center;
          height: 54px!important;
          line-height: 54px!important;
        }
      }
      li:hover {
        background: #aaa;
        border-bottom: 1px solid rgba(255,255,255,0.4)!important;
        a {
          color: #000!important;
        }
      }
      li:first-child {
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
      }
      li:last-child {
        border: 0!important;
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
      }
    }
    .case:hover {
      .case-item {
        display: block;
      }
    }
    .about:hover {
      .about-item {
        display: block;
      }
    }
  }
}
@media (max-width: 997px) {
  .main-header {
    padding: 0 30px;
    height: 60px;
    .logo {
      margin-top: 20px;
      .logo-img {
        width: 28px;
        margin-right: 5px;
      }
      a {
        font-size: 16px;
      }
    }
    .i-nav {
      width: 30px;
      height: 30px;
      margin-top: 15px;
      span {
        height: 3px;
        background: #fff;
        width: 30px;
        display: block;
      }
      span + span {
        margin-top: 10px;
      }
    }
    .nav {
      right: 30px;
      position: absolute;
      ul {
        display: none;
        position: absolute;
        top: 60px;
        width: 90px;
        right: -30px;
        box-shadow: 0 0 3px #aaa;
        li {
          height: 38px;
          line-height: 38px;
          border-bottom: 1px solid rgba(0,0,0,0.1);
          background: #fff;
          a {
            color: #000!important;
            font-size: 12px;
            display: block;
            text-align: center;
          }
        }
        li:last-child {
          border: 0!important;
          border-bottom-left-radius: 2px;
          border-bottom-right-radius: 2px;
        }
        .case-item, .about-item {
          display: none;
        }
      }
    }
    .show {
      display: block!important;
    }
  }
}
@media (max-width: 365px) {
  .logo {
    .logo-img {
        width: 22px!important;
        margin-right: 2px!important;
      }
    a {
      font-size: 13px!important;
    }
  }
}

.main-header {
  width: 100%;
  top: 0;
  position: fixed;
  background:rgba(0,0,0,0.5);
  z-index: 100000;
  .logo {
    float: left;
    .logo-img {
      float: left;
    }
  }
} 
</style>
